import { Injectable, inject } from "@angular/core";
import { Auth, updateProfile } from "@angular/fire/auth";
import { AuthService } from "./auth.service";

@Injectable()
export class UserService {

    private auth = inject(Auth);
    private authService = inject(AuthService);

    isLoggedIn() {
        return this.authService.authed;
    }

    getCurrentUser(): Promise<any> {
        const user = this.auth.currentUser;
        if (user && user.email === "denfordberriman@gmail.com") {
            return Promise.resolve(user);
        }
        return Promise.reject("No authorised user logged in");
    }

    updateCurrentUser(value: any) {
        const user = this.auth.currentUser;
        return updateProfile(user!, { displayName: value.name, photoURL: user!.photoURL });
    }
}
